import React, { PureComponent } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button as LegoButton, ButtonProps as LegoButtonProps } from 'lego-on-react';

import './button.css';

const isModifiedEvent = (event: any) => (
    Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey)
);

interface ButtonProps extends LegoButtonProps {
    disabled?: boolean;
    to?: string;
}

class Button extends PureComponent<ButtonProps & RouteComponentProps<any>> {
    /* tslint:disable-next-line cyclomatic-complexity */
    public handleClick = (event: any) => {
        const { to } = this.props;
        if (
            to &&
            !event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            !this.props.target && // let browser handle "target=_blank" etc.
            !isModifiedEvent(event) // ignore clicks with modifier keys
        ) {
            event.preventDefault();

            this.props.history.push(to);
        }
    };

    public render() {
        const {
            pin = 'round-round',
            size = 'm',
            theme = 'normal',
            children,
            ...props
        } = this.props;

        return (
            <LegoButton
                theme={theme}
                size={size}
                pin={pin}
                onClick={this.handleClick}
                {...props}
            >
                {children}
            </LegoButton>
        );
    }

}

export default withRouter(Button);
